import Dashboard, { DashboardAccess, DashboardOwner, DashboardPermittedActions } from 'domain/entity/dashboard';

export enum DASHBOARD_TYPE {
    REPORT_TEMPLATE = 'REPORT_TEMPLATE',
    DASHBOARD = 'DASHBOARD',
}
class ReportTemplate extends Dashboard {
    constructor(
        readonly id: string,
        readonly name: string,
        readonly pinned: boolean,
        readonly access: DashboardAccess,
        readonly owner: DashboardOwner,
        readonly permittedActions: DashboardPermittedActions,
        readonly starred: boolean,
        readonly type: DASHBOARD_TYPE,
        readonly description: string
    ) {
        super(id, name, pinned, access, owner, permittedActions, starred, type);
    }
}

export default ReportTemplate;
